/**
 * Layouts contributed by the NOVA feature: /nova is a full-page app with its own chrome, so it skips the site shell.
 */
import { NovaAuthLayoutRoute } from './NovaAuthLayoutRoute';
import { NovaLayoutRoute } from './NovaLayoutRoute';
import type { LayoutEntry } from './layouts';

export const entries: LayoutEntry[] = [
  // the sign-in page wears Nova's look; it sits above the standard /auth shell (order 210)
  { match: (p) => p === '/' || p === '/auth/login' || p === '/contact' || p === '/enter', Layout: NovaAuthLayoutRoute, order: 40 },
  // /dashboard (the page itself) is Nova's timeline; deeper /dashboard/* pages keep the standard dashboard shell
  { match: (p) => p === '/nova' || p.startsWith('/nova/') || ['/dashboard', '/profile', '/settings', '/about', '/credits', '/welcome', '/admin'].includes(p.replace(/\/+$/, '')), Layout: NovaLayoutRoute, order: 50 },
];
